<template>
  <div
    data-refid="globalSearchIcon"
    class="main-desktop-header-button"
    @click="handleOpen"
  >
    <MagnifyingGlassIcon class="main-desktop-header-icon" aria-hidden="true" />
  </div>
</template>

<script setup lang="ts">
import { markRaw } from 'vue'

import { useHotKeys } from '@/plugins/hotKeys'

import { useModalsStore } from '@/store/modals'

import { MagnifyingGlassIcon } from '@heroicons/vue/24/outline'
import HeaderSearchDialog from './HeaderSearchDialog.vue'

const modalsStore = useModalsStore()

const handleOpen = () => {
  const modalInstance = modalsStore.init('global-search', markRaw(HeaderSearchDialog))
  modalInstance?.open(modalsStore.getZIndex())
}

useHotKeys('search', handleOpen)
</script>
